import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, Command } from '../../../core/model/command';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { Invoice } from '../../model/invoice';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { Observable } from 'rxjs';
import { InvoiceStatus } from '../../model/const/enum';
import { MessageService } from '../../../core/service/message.service';
import { RegisterCustomerLossFormComponent } from '../../component/customer-loss-form/customer-loss-form.component';

@Injectable()
export class CustomerLossCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindow: ActionWindowService,
    private _injector: Injector,
    private _messageService: MessageService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command && command.context instanceof Invoice) {
      if (command.id !== invoiceCommand.customerLoss) {
        return false;
      }

      if (!command.context.attestedDate || !command.context.attestedDate.hasValue()) {
        this._messageService.showMessage('INVOICE.INFORMATION_TEXT.INVOICE_NOT_ATTESTED');
        return false;
      }

      if (command.context.isCreditInvoice) {
        this._messageService.showMessage('ERROR.ACTION_INVALID_FOR_CREDIT_INVOICE');
        return false;
      }

      if (command.context.remainingAmount.amount === 0) {
        this._messageService.showMessage('ERROR.INVOICE_FULLY_PAID');
        return false;
      }

      return true;
    }

    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._actionWindow.open(RegisterCustomerLossFormComponent, this._injector, null, command.context, true).pipe(
        map(res => {
          if (res instanceof Invoice) {
            Object.assign(command.context, res);
          }
        })
      );
    }
  }
}
